import { useHistory } from 'react-router-dom';

import { Location } from '@cobliteam/common-types/src/location';
import type { Preferences } from '@cobliteam/common-types/src/preferences';

import { useLocalStorage } from '@cobliteam/hooks';

import { EtaIcon } from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';
import InfoBanner from '@cobliteam/ui/components/InfoBanner';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const NewTriggersFeatureInfoBanner = () => {
  const [localStorage, setLocalStorage] = useLocalStorage<Preferences>('preferences');
  const history = useHistory();

  if (localStorage.hideNewTriggersFeatureInfoBanner) return null;

  return (
    <InfoBanner>
      <InfoBanner.Content>
        <InfoBanner.Icon icon={<EtaIcon />} />
        <InfoBanner.Text>
          <b>
            {`Em breve, regras personalizadas também poderão ser criadas para acompanhamento dos eventos na nova página de
            "Política de Frota".`}
          </b>
        </InfoBanner.Text>
      </InfoBanner.Content>

      <InfoBanner.Actions>
        <Button
          variant='text'
          size='condensed'
          onClick={() => {
            history.push(localStorage?.isFirstTriggersAccess ? Location.FLEET_POLICY_LP : Location.TRIGGERS);
          }}
        >
          Quero conhecer
        </Button>

        <Button
          variant='ghost'
          size='condensed'
          color='secondary'
          icon={<CloseRoundedIcon className='h-6 w-6' />}
          onClick={() =>
            setLocalStorage({
              ...localStorage,
              hideNewTriggersFeatureInfoBanner: true,
            })
          }
        />
      </InfoBanner.Actions>
    </InfoBanner>
  );
};

export default NewTriggersFeatureInfoBanner;
